import { createI18n } from 'vue-i18n';
import en from '../locales/en.json';
import ru from '../locales/ru.json';
import kk from '../locales/kk.json';

const savedLanguage = sessionStorage.getItem('lang') || 'ru';

const messages = {
  en,
  ru,
  kk,
};

const i18n = createI18n({
  legacy: false,
  locale: savedLanguage,
  fallbackLocale: 'ru',
  messages,
});

export default i18n;
